// extracted by mini-css-extract-plugin
export default {"wrapper":"RightsPage_wrapper__RBVF1","title":"RightsPage_title__uemRH","subTitle":"RightsPage_subTitle__qa2Ec","ulMargin":"RightsPage_ulMargin__SI-Hs"};